export class Contact {
    constructor(
        public nature?: string,
        public demande?: string,
        public formation?: string,
        public nom?: string,
        public prenom?: string,
        public email?: string,
        public dateNaissance?: any,
        public description?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/contact.model.ts